import { BaseTypeSchema } from "../BaseTypeSchema";
import { VariableType } from "../VariableType";

export class TimeSchema extends BaseTypeSchema
{
    static REGEX: RegExp = /^([01]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9](\.\d{1,3})?$/;
    constructor(required: boolean)
    {
        super(VariableType.Time, required);
    }
}